import { render, staticRenderFns } from "./DashIcon.vue?vue&type=template&id=3e798bb8&"
import script from "./DashIcon.vue?vue&type=script&lang=ts&"
export * from "./DashIcon.vue?vue&type=script&lang=ts&"
import style0 from "./DashIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports